/* Component Dependencies */
var dealSearchFormTemplate = require('templates/dealSearchForm.hbs');
var AriesComponent = require('libs/aries-component');
var AutoCompleteHandler = require('libs/auto-complete-handler');
var AutoCompleteHandlerV2 = require('libs/auto-complete-handler-v2');
var ResponsiveUtils = require('utils/responsiveUtils');
var googleApiWrapper = require('js-google-api-wrapper');
var GoogleAutocompleteHandler = require('libs/autocompleteHandler');
var AutocompleteFormFieldMapper = require('libs/autocompleteHandler/autocompleteFormFieldMapper');
var recentSearchService = require('libs/autocomplete/recentSearchService');
var $ = require('jquery');

AriesComponent.create({
  type: 'dealSearchForm',
  template: {
    'dealSearchForm': dealSearchFormTemplate
  },
  subscribe: {
    'ADVANCED_SEARCH_TAB_CLICK': 'toggleSearchOptions'
  },
  events: {
    'click .show-all-deals': 'showAllDeals',
    'click .narrow-deals-options': 'narrowDealsOptions',
    'click .js-list-open , .js-list-close': 'toggleDealsList'
  },
  unBindEvents: function($) {
    $('*[data-component-id="' + this.$el.data('component-id') + '"]').off();
    $('*[data-component-id="' + this.$el.data('component-id') + '"] *').off();
  },
  bindEvents: function() {
    var _self = this,
    dealsContainer = _self.$el.find('.l-deals-options');
    
    this.autocompleteInputEl = this.$el.find('input[name="destination"]')[0];
    this.enableGooglePlaceAutoSuggestion = this.$el.find('.deals-search-form').data('enable-google-places-api');
    this.enableCustomAutoSuggest = this.$el.find('.deals-search-form').data('custom-auto-suggest');
    this.resetFields();
    this.initResponsiveUtils();
    this.initAutocomplete();

    //Defect fix SRPE-26586
    if (navigator.userAgent.length && /iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      if (this.responsiveUtils.isMobile()) {
        this.$el.find('.js-auto-complete-input').css('font-size', '16px');
      }
    }
    // Defect-SRPE-33648 For non US state,state is removed from post data
    this.$el.find('form').submit(function() {
      if (_self.$el.find('.search-country').val() !== 'US') {
        _self.$el.find('.search-state').val('');
      }
    });

    //closing dropdown on outside click
    $(document).on('click',function(e){
      if(!(dealsContainer.hasClass('l-display-none'))){
        if($(e.target).closest(_self.$el.find('.l-deals-container')).length === 0) {
          dealsContainer.addClass("l-display-none");
          _self.updateSelectedDeals(); 
        }
      }
    });    

    //show all deals checkbox is checked if no checkbox is selected
    _self.$el.find('.js-deals-checkbox').on('change', function(){
      if((_self.$el.find('.js-deals-checkbox:checked')).length == 0) {
      _self.$el.find('.show-all-deals').prop('checked',true);
      }
    });
    //update selected checkbox
    _self.updateSelectedDeals();    

  },
  /**
  * This function is used to initiate responsive utils
  */
  initResponsiveUtils: function() {
    this.responsiveUtils = ResponsiveUtils.create();
    this.responsiveUtils.init();
  },
  resetFields: function() {
    this.$el.find('.search-city').val('');
    this.$el.find('.search-state').val('');
    this.$el.find('.search-country').val('');
  },
  initAutoCompleteHandler: function() {
    if(this.$el.find('.js-auto-complete').length) {
      this.autoCompleteHandler = AutoCompleteHandler.create({
        $el: this.$el.find('.js-auto-complete'),
        $parent: this,
        onListClose: function() {
          this.$el.find('.js-auto-complete-input').val('');
        }
      });
      this.autoCompleteHandler.init();
    }
  },
  initAutoCompleteHandlerV2: function() {
    if(this.$el.find('.js-auto-complete').length) {
      this.autoCompleteHandlerV2 = AutoCompleteHandlerV2.create({
        $el: this.$el.find('.js-auto-complete'),
        $parent: this,
        onListClose: function() {
          this.$el.find('.js-auto-complete-input-v2').val('');
        }
      });
      this.autoCompleteHandlerV2.init();
    }
  },
  toggleSearchOptions: function(target) {
    if(this.$el.attr('data-target') === target){
      this.$el.show();
    } else {
      this.$el.hide();
      this.$el.find('.js-auto-complete-input').val('');
    }
  },
  showAllDeals: function() {
    this.$el.find('.narrow-deals-options').prop('checked', false);
  },
  narrowDealsOptions: function(){
    this.$el.find('.show-all-deals').prop('checked', false);
  },
  /**
   * Conditionally initialize autocomplete handler for Marriott or Google Places API (R3 Change)
   */
  initAutocomplete: function() {
    var _self = this;
    var googleMapOptions = _self.$el.find(".search-google-map").data('options');
    var geoLocationCN = _self.$el.find('input[name="geoLocationCN"]').val() || null;
    var $listContainerEl = this.$el.find('.l-hsearch-loc');
    var autocompleteSupportedTypesString = _self.$el.data("autocomplete-supported-types");
    var autocompleteSupportedTypes = autocompleteSupportedTypesString.split(',');
    if(geoLocationCN !== 'true' || this.enableCustomAutoSuggest){
      if(this.enableCustomAutoSuggest){
        this.$el.find('#propertydeals-destination-airport').addClass('js-auto-complete-input-v2');
        _self.initAutoCompleteHandlerV2();
      }else{
        if (!this.enableGooglePlaceAutoSuggestion) {
          this.$el.find('#propertydeals-destination-airport').addClass('js-auto-complete-input');
          _self.initAutoCompleteHandler();
        } else {
          googleApiWrapper.loadApi(googleMapOptions.api)
            .then(function(apiWrapper) {
              // Google apiWrapper and autocomplete options are passed to autocomplete handler
              new GoogleAutocompleteHandler(_self, apiWrapper, {
                disableCurrentLocSearch: true,
                disableRecentSearch: true,
                listContainerEl: $listContainerEl,
                autocompleteSupportedTypes: autocompleteSupportedTypes,
                onListClose: function() {
                  _self.$el.find('.filter-airport').val('');
                }
              });
          });
        }
      }
    }
  },
  /**
   * toggle list on click of close and open icon
   */
  toggleDealsList : function(event){
    var _self = this,
    toggleButton = $(event.target);

    _self.$el.find('.l-deals-options').toggleClass('l-display-none');

    if(toggleButton.hasClass('js-list-close')) {
      _self.updateSelectedDeals();
    }

  },
  /**
   * appends selected checkboxes
   */
  updateSelectedDeals : function() {
    var _self = this,
    deals = '';

     //append checked checkboxes
    _self.$el.find('.js-deals-checkbox:checked').each(function(index) {
      if(index > 0) {
        deals += ',' + ' ' + $(this).next().text();
      }
      else {
        deals = $(this).next().text();
      }

    });

    _self.$el.find('.l-deals-selected').text(deals);
  }
});